import { z } from 'zod';

// ─── Upload validation (client-side pre-check before POST) ─────────────────

/** Allowed MIME types per spec §0 */
export const ALLOWED_MIMES = [
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp',
  'application/pdf',
  'text/plain',
  'text/csv',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
] as const;

export type AllowedMime = (typeof ALLOWED_MIMES)[number];

/** 5 MB limit per spec §0 */
export const MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024;

/** File object schema for upload (validates before sending to server) */
export const uploadFileSchema = z
  .instanceof(File)
  .refine((f) => f.size > 0, { message: '파일이 비어 있습니다.' })
  .refine((f) => f.size <= MAX_FILE_SIZE_BYTES, {
    message: '파일 크기가 5MB를 초과했습니다.',
  })
  .refine((f) => (ALLOWED_MIMES as readonly string[]).includes(f.type), {
    message: '허용되지 않는 파일 형식입니다.',
  });

/** Schema for the delete confirm dialog */
export const deleteConfirmSchema = z.object({
  fileId: z.string().min(1),
  originalName: z.string().min(1),
});

export type DeleteConfirmValues = z.infer<typeof deleteConfirmSchema>;

/** Pagination query params */
export const listQuerySchema = z.object({
  page: z.number().int().min(0).default(0),
  size: z.number().int().min(1).max(100).default(20),
});

export type ListQueryValues = z.infer<typeof listQuerySchema>;
